import React from 'react';
import { Shield, CheckCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

export const AboutSection = ({ aboutInfo }) => (
  <section id="about" className="py-12 md:py-16 lg:py-20 bg-slate-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
        <div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">{aboutInfo.title}</h2>
          <p className="text-base md:text-lg text-slate-700 mb-8">{aboutInfo.description}</p>
          <div className="space-y-3 mb-8">
            {aboutInfo.expertise.map((item) => (
              <div key={item} className="flex items-start space-x-2">
                <CheckCircle className="h-5 w-5 text-[#105EFF] flex-shrink-0 mt-0.5" />
                <span className="text-slate-700">{item}</span>
              </div>
            ))}
          </div>
          <Button asChild size="lg" className="bg-[#105EFF] hover:bg-[#0D4FCC] text-white">
            <a href="#contact">Work With Us</a>
          </Button>
        </div>
        <div>
          <Card className="border-slate-200">
            <CardHeader>
              <CardTitle className="text-slate-900">Certifications & Expertise</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-1 gap-3">
                {aboutInfo.certifications.map((cert) => (
                  <div key={cert.name} className="flex flex-col sm:flex-row sm:items-center sm:justify-between p-3 bg-slate-50 rounded-lg gap-2">
                    <div className="flex items-center space-x-3">
                      <Shield className="h-5 w-5 text-[#105EFF] flex-shrink-0" />
                      <span className="text-slate-700 font-medium">{cert.name}</span>
                    </div>
                    <span className="text-slate-500 text-sm sm:text-right pl-8 sm:pl-0">{cert.expertise}</span>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  </section>
);
